import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderFillResultImplEncoder } from "../../encoder/OrderFillResultImplEncoder";

import * as CubiqTS from "../../index";
import { OrderFillResult } from "../OrderFillResult";

export class OrderFillResultImpl extends ConcreteEncodable implements OrderFillResult {
  public static enType: string = "com.bcdfx.service.OrderFillResultImpl";

  /*FID=1*/
  public orderId: string;
  /*FID=2*/
  public orderState: CubiqTS.OrderState;
  /*FID=3*/
  public errors: CubiqTS.Errors | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderFillResultImplEncoder.Instance;
    this.setEncodableType(OrderFillResultImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OrderFillResultImpl[" +
      "orderId=" +
      this.orderId +
      "orderState=" +
      this.orderState +
      "errors=" +
      this.errors +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
